import { useEffect } from 'react';
import { message } from 'antd';

import {
  useClaimBusinesses as useClaimBusinessesApi,
} from '../../../hooks/api/claimBusiness';
import { getMessageInError } from '../../../hooks/fetch';

export const useClaimBusinesses = () => {
  const {
    fetch: claimBusiness, response, error, loading,
  } = useClaimBusinessesApi();

  useEffect(() => {
    if (response?.data.success) {
      message.success('Business claimed successfully');
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      message.error(getMessageInError(error));
    }
  }, [error]);

  return {
    claimBusiness,
    response,
    error,
    loading,
  };
};

export default useClaimBusinesses;
